import React, { useEffect } from 'react';
import StickyBox from 'react-sticky-box';

import { useSectionRefs } from '../../tools/hooks/useSectionRefs';
import RichTextArticle from './RichText/RichTextArticle';
import TableOfContents from './TableOfContents/TableOfContents';

const ArticleWithToC = ({
  articleOverrides,
  tableOfContents,
  additionalResources,
  article,
  location,
  onScrollToTop,
  ...rest
}) => {
  const { visibleSection } = useSectionRefs(tableOfContents);

  useEffect(() => {
    if (onScrollToTop) {
      onScrollToTop(); // or save for later
    }
  }, [onScrollToTop]);

  useEffect(() => {
    // Scroll to anchor if URL has hash in SSR-safe way
    const { hash } = location || {};
    if (hash && typeof window !== 'undefined') {
      requestAnimationFrame(() => {
        const anchor = document.querySelector(hash);
        if (anchor) {
          const offset = anchor.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: offset, left: 0 });
        }
      });
    }
  }, [location]);

  const hasSidebar = (tableOfContents?.length || 0) > 0 || (additionalResources?.length || 0) > 0;

  return (
    <div {...rest}>
      {hasSidebar && (
        <StickyBox offsetTop={104} offsetBottom={10}>
          {tableOfContents && (
            <TableOfContents
              localLinks
              title="Table of Contents"
              currentSection={visibleSection}
              items={tableOfContents}
            />
          )}
          {additionalResources && <TableOfContents card title="Additional Resources" items={additionalResources} />}
        </StickyBox>
      )}
      <div id="article">
        <RichTextArticle copy={article} optionsOverride={articleOverrides} />
      </div>
    </div>
  );
};

export default ArticleWithToC;
